import { Button } from 'antd';
import styled from 'styled-components';

export const LicensesTableUsersItemStyled = styled.p<{ isBlocked?: boolean }>`
	margin: 0;
	color: ${props => (props.isBlocked ? `#FF4D4F` : `#262626`)};
	white-space: pre-wrap;
	font-size: 14px;
`;

export const ButtonStyled = styled(Button)`
	padding: 0;
	height: 22px;
`;

export const ModalContentStyled = styled.ul`
	display: flex;
	flex-direction: column;
	flex-wrap: wrap;
	overflow-x: scroll;
	overflow-y: hidden;
	padding-left: 16px;
	max-height: 140px;
	column-gap: 24px;
`;

export const LiStyled = styled.li`
	width: 150px;
	&::marker {
		padding: 0;
		font-size: 12px;
	}
`;

export const ModalHeaderStyled = styled.h1`
	font-size: 20px;
`;

export const BlockedUnitsNotificationStyled = styled.div`
	gap: 6px;
	display: flex;
	align-items: flex-start;
`;
